import React from 'react';
import Localize from 'react-intl-universal';
import { NavLink } from 'react-router-dom';

import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material/styles';

import { useGlobalContext } from '@hooks/Context/GlobalContext';

const StyledLogo = styled(Box)(({ theme }) => {
  const logoUrl = new URL(`../../assets/Images/${theme.logoName}`, import.meta.url).href;

  return {
    height: '1.5rem',
    minWidth: `${theme?.header?.logoWidth || '3.5rem'}`,
    verticalAlign: 'middle',
    backgroundImage: `url(${logoUrl})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'left',
    [theme.breakpoints.up(1675)]: {
      height: `${theme.header.logoHeight || '2rem'}`
    }
  };
});

const StyledLogoIcon = styled(Box)(({ theme }) => {
  const logoIcon = new URL(`../../assets/Images/${theme.logoIcon}`, import.meta.url).href;
  return {
    height: '1.5rem',
    minWidth: '3.5rem',
    verticalAlign: 'middle',
    backgroundImage: `url(${logoIcon})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'left',
    [theme.breakpoints.up(1675)]: {
      height: `${theme.header.logoHeight || '2rem'}`
    }
  };
});

const LogoLink = ({ pathname = '/', from = '', path = '', hasHomePage = false, disabled }) => {
  const theme = useTheme();
  const [contextData] = useGlobalContext();

  const Logo = (
    <Box sx={{ display: 'flex' }}>
      <StyledLogo />
      {theme?.logoIcon && <StyledLogoIcon />}
    </Box>
  );

  const isStaticLogo = !contextData?.isCatalogVisible && !hasHomePage;

  if (isStaticLogo) return Logo;

  return disabled ? (
    Logo
  ) : (
    <NavLink to={{ pathname, state: { from, path } }} aria-label={Localize.get('AppNavBar.home')}>
      {Logo}
    </NavLink>
  );
};

export default LogoLink;
